var quantityButtons = document.querySelectorAll("[data-quantity]");

for (var i = 0; i < quantityButtons.length; i++) {
  var item = quantityButtons[i];

  (function (item) {
    item.addEventListener("click", function (e) {
      var value = e.target.getAttribute("data-quantity");
      var quantityEl = item.parentNode.querySelector("[data-quantity-value]");
      var quantityValue = quantityEl.value;

      if (value * 1 < 0) {
        if (quantityValue > 1) {
          quantityEl.value = quantityValue * 1 - 1;
        }
      }

      if (value * 1 > 0) {
        quantityEl.value = quantityValue * 1 + 1;
      }

      // updatePrice();
    });
  })(item);
}